export default __webpack_public_path__ + "images/kvd-noimage.png";